/**
 * 批量打标弹窗内资源展示辅助：类型 pill 色与状态文案。
 * 与主列表 list.vue 语义保持一致，避免弹窗内选择器与列表视觉割裂。
 */

/** 资源类型 pill 语义色：与主列表 list.vue / linkSemanticPills 保持一致。 */
export function getTypeTagVariant(typeName) {
  const raw = String(typeName || '').trim()
  if (!raw) {
    return 'neutral'
  }
  const key = raw.toLowerCase()
  if (/recipe/.test(key)) {
    return 'amber'
  }
  if (/puzzle|level/.test(key)) {
    return 'sky'
  }
  if (/视频|video|mp4|mov/.test(key)) {
    return 'video'
  }
  if (/图片|图像|image|photo|wallpaper|静态/.test(key)) {
    return 'image'
  }
  if (/链接|link|url|跳转|web|网页|coupon|优惠券/.test(key)) {
    return 'link'
  }
  if (/音频|audio|music|白噪音/.test(key)) {
    return 'audio'
  }
  if (/live|动态|gif|animation/.test(key)) {
    return 'motion'
  }
  const palette = ['sky', 'violet', 'amber', 'rose', 'teal', 'indigo']
  let hash = 0
  for (let i = 0; i < raw.length; i += 1) {
    hash = raw.charCodeAt(i) + ((hash << 5) - hash)
  }
  return palette[Math.abs(hash) % palette.length]
}

/** 资源状态文案，与列表筛选项一致。 */
export function getStatusLabel(onOrOff) {
  if (onOrOff === 1) {
    return '上线'
  }
  if (onOrOff === 0) {
    return '下线'
  }
  if (onOrOff === 10) {
    return '处理中'
  }
  if (onOrOff === 12) {
    return '等待重试'
  }
  if (onOrOff === 11) {
    return '处理失败'
  }
  return '未知'
}

/** 状态 pill 语义变体。 */
export function getStatusPillVariant(onOrOff) {
  if (onOrOff === 1) {
    return 'online'
  }
  if (onOrOff === 0) {
    return 'offline'
  }
  if (onOrOff === 10 || onOrOff === 12) {
    return 'pending'
  }
  if (onOrOff === 11) {
    return 'failed'
  }
  return 'offline'
}

/** 布尔 exta 字段 pill 文案（挑选弹窗 loopable 列）。 */
export function formatBoolPillLabel(value) {
  if (value === true || value === 'true') {
    return 'true'
  }
  if (value === false || value === 'false') {
    return 'false'
  }
  return '—'
}

/** 布尔 exta 字段 pill 语义色：true 对齐上线绿，false 对齐下线灰。 */
export function getBoolPillVariant(value) {
  if (value === true || value === 'true') {
    return 'online'
  }
  if (value === false || value === 'false') {
    return 'offline'
  }
  return 'pending'
}

export function resourceTitle(row) {
  return row.resourceName || row.wallpaperName || row.key || '—'
}
